import {NotificationProps} from "../notification/notification-view";
import Notification from "../notification";
import "./unrecoverable-error.scss";

export interface UnrecoverableErrorProps extends NotificationProps {

}
function UnrecoverableError(props: UnrecoverableErrorProps) {
  const {
    className,
      ...other
  } = props;
  return <Notification {...other} className={(className ? className : "") + " Unrecoverable-error"} />;
}
export default UnrecoverableError;
